//tools
import cc from "classcat";

//styles
import styles from "./MessagesSkeleton.module.css";

const MessagesSkeleton = () => (
  <>
    <div className={cc([styles["skeleton-message"]])}>
      <div className={styles["skeleton-avatar"]} />
      <div className={styles["skeleton-content"]}>
        <div className={styles["skeleton-author"]} />
        <div className={styles["skeleton-text"]} />
        <div className={styles["skeleton-text-short"]} />
      </div>
    </div>
    <div className={cc([styles["skeleton-message"], styles["skeleton-message-user"]])}>
      <div className={styles["skeleton-avatar"]} />
      <div className={styles["skeleton-content"]}>
        <div className={styles["skeleton-author"]} />
        <div className={styles["skeleton-text"]} />
      </div>
    </div>
    <div className={cc([styles["skeleton-message"]])}>
      <div className={styles["skeleton-avatar"]} />
      <div className={styles["skeleton-content"]}>
        <div className={styles["skeleton-author"]} />
        <div className={styles["skeleton-text"]} />
        <div className={styles["skeleton-text-short"]} />
      </div>
    </div>
  </>
);

export default MessagesSkeleton;